import PropTypes from "prop-types";

import BasicRender from "./BasicRender";

/**
 *
 * Component renders a list of editable templates of type image
 */
const ImageRender = ({ imageTemplate, onRemove, isEditable }) => {
  return (
    <BasicRender
      datasetTemplate={imageTemplate}
      onRemove={onRemove}
      isEditable={isEditable}
    />
  );
};

ImageRender.propTypes = {
  imageTemplate: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  isEditable: PropTypes.bool,
};

export default ImageRender;
